export const ROUTE_HOME = '/';
export const ROUTE_LOGIN = '/connexion';
export const ROUTE_PROFILE = '/mon-profil';



// WEBPACK FOOTER //
// ./src/routes.js